import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DemoCredentials = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const credentials = [
    { role: 'Admin', email: 'admin@ecity.com', password: 'Admin@2026' },
    { role: 'Estimator', email: 'estimator@ecity.com', password: 'Estimator@2026' },
    { role: 'Procurement', email: 'procurement@ecity.com', password: 'Procurement@2026' },
    { role: 'Finance', email: 'finance@ecity.com', password: 'Finance@2026' },
    { role: 'Management', email: 'management@ecity.com', password: 'Management@2026' }
  ];

  const handleCopyCredentials = (email, password) => {
    const text = `Email: ${email}\nPassword: ${password}`;
    navigator.clipboard?.writeText(text);
  };

  return (
    <div className="mt-6 md:mt-8">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between p-4 rounded-lg bg-muted hover:bg-muted/80 transition-smooth"
      >
        <div className="flex items-center gap-2">
          <Icon name="Info" size={18} color="var(--color-primary)" />
          <span className="text-sm font-medium text-foreground">
            Demo Credentials
          </span>
        </div>
        <Icon 
          name={isExpanded ? 'ChevronUp' : 'ChevronDown'} 
          size={18} 
          className="text-muted-foreground"
        />
      </button>
      {isExpanded && (
        <div className="mt-3 p-4 rounded-lg bg-card border border-border space-y-3">
          <p className="text-xs text-muted-foreground mb-4">
            Use these credentials to explore different role-based access levels
          </p>
          {credentials?.map((cred, index) => (
            <div
              key={index}
              className="flex items-center justify-between p-3 rounded-md bg-muted/50 hover:bg-muted transition-smooth"
            >
              <div className="flex-1 min-w-0">
                <div className="text-xs font-semibold text-foreground mb-1">
                  {cred?.role}
                </div>
                <div className="text-xs text-muted-foreground truncate">
                  {cred?.email}
                </div>
                <div className="text-xs text-muted-foreground font-mono">
                  {cred?.password}
                </div>
              </div>
              <Button
                variant="ghost"
                size="sm"
                iconName="Copy"
                iconSize={14}
                onClick={() => handleCopyCredentials(cred?.email, cred?.password)}
                className="flex-shrink-0"
              >
                Copy
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DemoCredentials;